/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Forced_Subtitle_LabelInputs */

const en_style_guide_manager_forced_subtitle_label = /** @type {(inputs: Style_Guide_Manager_Forced_Subtitle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forced Subtitle`)
};

const fr_style_guide_manager_forced_subtitle_label = /** @type {(inputs: Style_Guide_Manager_Forced_Subtitle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sous-titre force`)
};

const de_style_guide_manager_forced_subtitle_label = /** @type {(inputs: Style_Guide_Manager_Forced_Subtitle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erzwungener Untertitel`)
};

const it_style_guide_manager_forced_subtitle_label = /** @type {(inputs: Style_Guide_Manager_Forced_Subtitle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sottotitoli forzati`)
};

const ru_style_guide_manager_forced_subtitle_label = /** @type {(inputs: Style_Guide_Manager_Forced_Subtitle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Принудительные субтитры`)
};

const es_style_guide_manager_forced_subtitle_label = /** @type {(inputs: Style_Guide_Manager_Forced_Subtitle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtítulo forzado`)
};

const zh_cn2_style_guide_manager_forced_subtitle_label = /** @type {(inputs: Style_Guide_Manager_Forced_Subtitle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`强制字幕`)
};

const ja_style_guide_manager_forced_subtitle_label = /** @type {(inputs: Style_Guide_Manager_Forced_Subtitle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`強制字幕`)
};

const hi_style_guide_manager_forced_subtitle_label = /** @type {(inputs: Style_Guide_Manager_Forced_Subtitle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनिवार्य उपशीर्षक`)
};

const pt_pt2_style_guide_manager_forced_subtitle_label = /** @type {(inputs: Style_Guide_Manager_Forced_Subtitle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legenda forçada`)
};

/**
* | output |
* | --- |
* | "Forced Subtitle" |
*
* @param {Style_Guide_Manager_Forced_Subtitle_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_forced_subtitle_label = /** @type {((inputs?: Style_Guide_Manager_Forced_Subtitle_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Forced_Subtitle_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_forced_subtitle_label(inputs)
	if (locale === "de") return de_style_guide_manager_forced_subtitle_label(inputs)
	if (locale === "it") return it_style_guide_manager_forced_subtitle_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_forced_subtitle_label(inputs)
	if (locale === "es") return es_style_guide_manager_forced_subtitle_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_forced_subtitle_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_forced_subtitle_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_forced_subtitle_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_forced_subtitle_label(inputs)
	return en_style_guide_manager_forced_subtitle_label(inputs)
});